import script from "./SlideToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./SlideToolbar.vue?vue&type=style&index=0&id=24150aba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24150aba"]])

export default __exports__